import { useMutation, useQueryClient } from "react-query";
import http from "infra/http";
import { showErrorAxios } from "infra/helpers/alerta";

function useEstornarConta(invalidateQuery = "v1/conta") {
  const queryClient = useQueryClient();
  return useMutation(
    (id: string) => {
      return http.post(`/v1/conta/${id}/estornar`);
    },
    {
      retry: false,
      onError: (e) => {
        showErrorAxios(e);
      },
      onSuccess: () => {
        if (invalidateQuery) {
          queryClient.invalidateQueries({
            predicate: ({ queryKey }) =>
              typeof queryKey === "string" && queryKey.startsWith(invalidateQuery),
          });
        }
        
      },
    }
  );
}

export default useEstornarConta;
